import { useHistory, useRouteMatch } from 'react-router';
import { IForumService, Thread, Topics } from '../model/interfaces';
import { container } from 'tsyringe';
import { Loader } from '@ui-kit/components/loader';
import { useParams } from 'react-router-dom';
import TopicsListHeader from './topicsListHeader';
import styles from '../styles/topicsList.module.scss';
import { forumId } from '../constants/forumId';
import { useState, useEffect } from 'react';
import { SkipBtn } from '.';
import Topic from './topic';
import { useBehaviorSubject } from '@base/utils/helpers';

type RouteParams = {
  threadsName: string;
  countPage: string;
};

function TopicsList() {
  const history = useHistory();
  const { url } = useRouteMatch();
  const forumService: IForumService = container.resolve('forumService');
  const { threadsName, countPage = 0 } = useParams<RouteParams>();
  const [data, setData] = useState<Topics>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();
  const isModer = useBehaviorSubject(forumService.isModerating);

  useEffect(() => {
    if (loading) return;
    let isMounted = true;
    setLoading(true);
    forumService
      .getTopicsListWithSkipNumberOfTopics(forumId[threadsName], Number(countPage) * 20)
      .then((res) => {
        if (isMounted) setData(res);
      })
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
    return () => {
      isMounted = false;
    };
  }, [threadsName, countPage, forumService]);

  if (!data) return null;
  if (loading) return <Loader />;

  return (
    <>
      <TopicsListHeader />
      <div className={styles.mainBody}>
        {data.threads &&
          data.threads.map((th: Thread, i: number) => {
            if (!isModer && th.State === 'H') return null;

            return (
              <Topic
                key={i}
                onClick={() => history.push(url + '/' + th.ThreadID)}
                title={th.Topic}
                repliesCount={th.RepliesCount}
                creator={th.Creator}
                creationTime={th.CreationTime}
                lastPostTime={th.LastPostTime}
                priority={th.Priority}
              />
            );
          })}
        <SkipBtn
          prev={() => (Number(countPage) > 0 ? history.goBack() : '')}
          next={() =>
            data.threads?.length < 20
              ? ''
              : history.push(url.replace(/\/p-\d+/g, '') + '/p-' + (Number(countPage) + 1))
          }
        />
      </div>
    </>
  );
}

export default TopicsList;
